import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { formatCurrency } from "../utils/currency";
import "../styles/pages/MobileMarketplace.css";
import { Link } from "react-router-dom";
import { MobilePageHeader } from "../components/layout/MobileAppChrome";
import ActionSwitchPill from "../components/shared/ActionSwitchPill";

const accountLinks = [
  { to: "/orders", label: "My Orders", icon: "📦" },
  { to: "/address", label: "My Addresses", icon: "📍" },
  { to: "/wallet", label: "My Wallet", icon: "💳", meta: true },
  { to: "/coupons", label: "Coupons & Offers", icon: "🏷️" },
  { to: "/wishlist", label: "My Wishlist", icon: "❤️" },
  { to: "/service-tracking", label: "Service Tracking", icon: "📈" },
  { to: "/bulk-order", label: "Bulk Inquiries", icon: "📦" },
  { to: "/about", label: "About Eldoo", icon: "ℹ️" },
  { to: "/terms", label: "Terms & Conditions", icon: "📜" },
  { to: "/returns", label: "Return & Refund Policy", icon: "↩️" },
  { to: "/privacy", label: "Privacy Policy", icon: "🔒" },
];

const ProfilePage: React.FC = () => {
  const { logout, updateDeliveryPreference, user } = useAuth();
  const [savingDeliveryMode, setSavingDeliveryMode] = useState(false);
  const fullName = user?.fullName || "";
  const phoneNumber = user?.phoneNumber || "";
  const email = user?.email || "";
  const activeSide = user?.preferredDeliveryMode === "STORE_PICKUP" ? "left" : "right";

  const handleDeliveryModeSwitch = async () => {
    if (savingDeliveryMode) {
      return;
    }

    setSavingDeliveryMode(true);
    try {
      await updateDeliveryPreference(activeSide === "right" ? "STORE_PICKUP" : "HOME_DELIVERY");
    } finally {
      setSavingDeliveryMode(false);
    }
  };

  return (
    <section className="shell section page-section profile-page">
      <div className="profile-mobile-view">
        <MobilePageHeader title="My Account" />
        <div className="profile-mobile-user">
          <span>{fullName.slice(0, 1) || "E"}</span>
          <div>
            <strong>{fullName || "Eldoo Customer"}</strong>
            <small>{phoneNumber || email || "Complete your profile"}</small>
          </div>
          <Link to="/account/edit-profile" aria-label="Edit profile">
            Edit profile
          </Link>
        </div>
        <section className="store-card profile-page__delivery-card">
          <span className="eyebrow">Fulfilment</span>
          <h2>Switch pickup or home delivery</h2>
          <ActionSwitchPill
            leftLabel="Store pickup"
            rightLabel="Home delivery"
            activeSide={activeSide}
            tone="delivery"
            className="profile-page__delivery-switch"
            showCaption={false}
            disabled={savingDeliveryMode}
            onClick={() => void handleDeliveryModeSwitch()}
            ariaLabel="Switch your default fulfilment mode"
          />
        </section>
        <nav className="profile-mobile-menu">
          {accountLinks.map((item) => (
            <Link key={item.label} to={item.to}>
              <span>{item.icon}</span>
              {item.label}
              {item.meta ? <em>{formatCurrency(user?.walletBalance || 0)}</em> : null}
            </Link>
          ))}
          <button type="button" onClick={logout}>
            <span>↪️</span>
            Logout
          </button>
        </nav>
      </div>
    </section>
  );
};

export default ProfilePage;
